import React from 'react';
import RangeSlider from 'components/RangeSlider';
import { APP_PERCENT } from 'constants/constants';

type SliderTableRendererProps = {
    value?: number;
    id: number;
    disabled?: boolean;
    onChange?: (value: { id: number; value: number }) => void;
};

const SliderTableRenderer = ({
    value = 0, id, disabled = false, onChange = () => null,
}: SliderTableRendererProps) => {
    if (value === undefined) return null;

    return (
        <div className="SliderTableRenderer-Cell">
            <RangeSlider
                disabled={disabled}
                data-cy="security-allocation"
                value={value}
                min={10}
                max={90}
                step={1}
                suffix={`${APP_PERCENT}`}
                unit={false}
                withInput
                onChange={(val: string | number) => onChange({ id, value: parseInt(String(val), 10) })}
                disableExceedingMaxValue
            />
        </div>
    );
};

export default SliderTableRenderer;
